<template>
  <div class="AddSchedule lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddSchedule-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddSchedule-main lxn-pos-rel">
      <div class="AddSchedule-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSchedule_title1}}
          </template>
          <template v-slot:body>
            <div class="AddSchedule-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="AddSchedule-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="AddSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="AddSchedule-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="AddSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="AddSchedule-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="AddSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="AddSchedule-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="AddSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="AddSchedule-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="AddSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSchedule_text1}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="ScheduleName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddSchedule_namePlaceHolder" inputType="text" />
            </div>
            <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSchedule_text2}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetHub" :dropDownContex="dropDownTargetHub" />
            </div>
          </template>
        </TitleBox>
        <Instruction :types="types" ref="conditions" :instructionId="instructionId" :titleBgColor="titleBgColor" :condition="condition" :targetHub="targetHub" :bgColor="'#ECECEC'"></Instruction>
      </div>
      <div class="AddSchedule-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddSchedule_button}}
        </CustomButton>
      </div>
      <div v-if="isEdit" class="AddSchedule-button lxn-margin-auto lxn-w100">
        <!-- //TODO: check if schedules are loaded and there exists a scene in target hub -->
        <CustomButton @click="deleteSchedule" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#F5C7BD" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddSchedule_button3}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CommandCreator from '@/components/CommandCreator.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import CustomInput from '@/components/CustomInput.vue'
import DropDown from '@/components/DropDown.vue'
import NumberInputSpinner from '@/components/NumberInputSpinner.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'
import Vue from 'vue'
import SingleSwitch from "@/components/SingleSwitch";
import * as moment from 'jalali-moment';
import Instruction from "@/components/Instruction/Instruction";

var messaging = new Messaging(new Logger(false));

export default {
  name: 'AddSchedule',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    DropDown,
    NumberInputSpinner,
    CommandCreator,
    Instruction,
    SingleSwitch
  },
  data: function () {
    return {
      instructionId: parseInt(this.$route.params.instructionId) || null,
      isEdit: this.$route.params.instructionId !== undefined,
      ScheduleName: '',
      input1State: '',
      activeBoxIndex: 0,
      types: [CONFIGS.INSTRUCTION_CONDITION_TYPE.SINGLESHOT, CONFIGS.INSTRUCTION_CONDITION_TYPE.WEEKLY, CONFIGS.INSTRUCTION_CONDITION_TYPE.PERIODIC],
      condition: {type: 0, conditions: []},
      targetHub: 0,
    }
  },
  mounted: function () {
    if (this.isEdit){
      this.$store.commit('setAppBusy', true);
      setTimeout(() => {
        const schedule = this.$store.state.schedules.find(x => x.instructionId === this.instructionId)
        this.getHubInstructions(schedule);
      }, 2000)
    }
  },
  watch: {
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    dropDownTargetHub: function () {
      var dropDownTargetHub = {
        name: "AddSchedules-TargetHubs",
        title: this.$store.getters.language.texts.AddSchedule_text2,
        selectedIndex: this.targetHub,
        data: []
      };
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        dropDownTargetHub.data.push({
          name: this.$store.state.hubs[i].name,
          icon: "hub",
        })
      }
      return dropDownTargetHub;
    },
  },
  methods: {
    getColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.ScheduleName === ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddSchedule_alert1);
      }else {
        const condition = this.$refs.conditions.getData();
        if (condition === null){
          return;
        }
        this.$store.commit('setAppBusy', true);
        const hub = this.$store.state.hubs[this.targetHub];
        const messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: hub.psk,
          destinationUUID: hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });

        const schedule = {
          name: this.ScheduleName,
          color: this.activeBoxIndex,
          hubUUID: hub.uuid,
          instructions: [condition]
        };
        this.$store.dispatch('setInstructionsOnHub', {
          messagingHook: messagingHook,
          hubUUID: hub.uuid,
          instructions: schedule.instructions,
        })
            .then( (response) => {
              this.$store.commit(this.isEdit ? 'updateSchedule' : 'addSchedule', {
                name: schedule.name,
                color: schedule.color,
                instructionId: this.instructionId,
              });
              this.$store.commit("saveState");
              this.$router.push('/schedules');
            })
            .catch(response => {
              if(response.rejectCode === 2){
                this.$store.commit('setHubStatus', {
                  hubIndex: response.hubIndex,
                  connectionStatus: {
                    local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                    online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  },
                });
              }
              this.$store.commit('setAppBusy', false);
            })
      }
    },
    getHubInstructions: function (scheduleState) {
      const hub = this.$store.state.hubs.find(x => x.uuid === scheduleState.hubUUID);
      const psk = hub.psk;
      const destinationUUID = hub.uuid;
      const messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: psk,
        destinationUUID: destinationUUID,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('readHubInstructions', {
        messagingHook: messagingHook,
        hubUUID: destinationUUID,
      })
          .then(response => {
            const schedule = response.body.bodyContent.instructionList.find(x => x.instructionId === this.instructionId);
            this.ScheduleName = scheduleState.name;
            this.activeBoxIndex = scheduleState.color;
            this.targetHub = hub.index;
            this.$refs.conditions.setData(schedule);
            this.$store.commit('setAppBusy', false);
          })
          .catch( response => {
            if(response.rejectCode === 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
              this.$store.commit('setAppBusy', false);
            }
          });
    },
    deleteSchedule: async function () {
      const hub = this.$store.state.hubs[this.targetHub];
      const messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('removeHubInstruction', {
        messagingHook: messagingHook,
        hubUUID: hub.uuid,
        instructions: [this.instructionId],
      })
          .then( () => {
            this.$store.commit('deleteSchedule', this.instructionId);
            this.$store.commit("saveState");
            this.$router.push('/schedules');
            this.$store.commit('setAppBusy', false);
          })
          .catch(response => {
            if(response.rejectCode === 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
            this.$store.commit('setAppBusy', false);
          })
    },
  }
}
</script>

<style>
  .AddSchedule-topCurve-wrapper {
    height: 200px;
  }
  .AddSchedule-main {
    z-index: 2;
  }
  .AddSchedule-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .AddSchedule-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .AddSchedule-wrapper-colors {
    height: 50px;
  }
  .AddSchedule-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .AddSchedule-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .AddSchedule-color.active .AddSchedule-selectedColor {
    opacity: 1;
  }
  .AddSchedule-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .AddSchedule-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .AddSchedule-wrapper-name-text:first-child {
    height: 30px;
    padding-top: 0;
  }
  .AddSchedule-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .AddSchedule-commandDelay-button {
    -webkit-appearance: none;
    transition: opacity 0.5s ease;
    background: #1EA5DE;
    border: 0;
    border-radius: 7px;
    overflow: hidden;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;
  }
  .AddSchedule-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddSchedule-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddSchedule-commandDelay-button:focus {
      outline: 0;
      outline-offset: 0;
  }
  .AddSchedule-todayOnly {
    display: table;
    padding-left: 20px;
    padding-right: 20px;
    line-height: 40px;
    line-height: 40px;
    background-color: #53636C;
    color: #FFFFFF;
  }
  .AddSchedule-todayOnly.active {
    background-color: #1EA5DE;
  }
  .AddSchedule-days {
    width: calc(100% / 7 - 4px);
    height: 40px;
    margin-right: 2px;
    margin-left: 2px;
    line-height: 40px;
    background-color: #53636C;
    color: #FFFFFF;
  }
  .AddSchedule-days.AddSchedule-days-mini {
    height: 18px;
    margin-right: 1px;
    margin-left: 1px;
    font-size: 10px;
    line-height: 18px;
  }
  .AddSchedule-days.active {
    background-color: #1EA5DE;
  }
</style>
